<template>
  <div class="head-info">
    <div class="infoList" v-for="(item, i) in infoList" :key="i">
      <div class="infoName">{{ item.filedName }}</div>
      <div class="infoData">{{ item.filedUnit }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["infoData"],
  data() {
    return {
      infoList: [],
      getDataInterval: null,
    };
  },
  created() {
  },
  mounted() {
    this.getDataInterval = setInterval(() => {
      this.infoList = this.infoData;
    }, 1000);
  },
  methods: {},
  watch:{
    infoData:{
      handler(newValue,oldValue){
        this.infoList = newValue;
      },
      deep:true
    }
  },
  destroyed() {
    //清除定时器
    if (this.getDataInterval) clearInterval(this.getDataInterval);
  },
};
</script>
<style lang="less" scoped>
.head-info {
  display: flex;
  justify-content: space-between;

  .infoList {
    width: 152px;
    height: 70px;
    background: url("./images/info-border.png") no-repeat 0 0;
    background-size: 100% 100%;

    .infoName {
      width: 100%;
      height: 30px;
      background: rgba(0, 0, 0, 0.1)
        linear-gradient(
          90deg,
          rgba(0, 145, 255, 0.1) 0%,
          rgba(0, 145, 255, 0.6) 48%,
          rgba(0, 145, 255, 0.1) 100%
        );
      text-align: center;
      line-height: 30px;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
    }

    .infoData {
      width: 100%;
      height: 40px;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      line-height: 40px;
      color: #ff7700;
      background: linear-gradient(180deg, #ffffff 0%, #00dbff 100%);
      background-clip: text;
      // 打开会报警告
      // -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
</style>